import { Paper, styled } from '@mui/material';

import { PageLayout } from '@/legacy/components/PageLayout/PageLayout';

export const StyledPageLayout = styled(PageLayout)(() => ({
  maxHeight: '100vh',
  '& > div:last-of-type': {
    flexGrow: 1,
    minHeight: 0,
  },
}));

export const CockpitPanelPaper = styled(Paper)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  [theme.breakpoints.down('md')]: {
    width: 300,
    minWidth: 300,
  },
  [theme.breakpoints.up('md')]: {
    width: 344,
    minWidth: 344,
  },
}));
